function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from "react";
import { useActionRegistryGlobalHandler } from "@sprout/list-navigation";
import { useSetItemsArchived, useSetItemsDeleted } from "@sprout/client-graphql";
import useDeleteItems from "@sprout/client-graphql/dist/mutations/useDeleteItems";
import { useParams } from "react-router-dom";
import TopicPageViewsTabsInfiniteList from "./TopicPageViewsTabsInfiniteList";
const SUPPORTED_ACTIONS = [
    "OPEN",
    "OPEN_EXTERNAL"
];
const TopicPageViewsTabsPosts = (props)=>{
    const { posts , updateList  } = props, rest = _objectWithoutProperties(props, [
        "posts",
        "updateList"
    ]);
    const navigationListOptions = useMemo(()=>({
            multiselect: true,
            actions: SUPPORTED_ACTIONS
        }), []);
    const { view  } = useParams();
    const setItemsArchived = useSetItemsArchived();
    const setItemsDeleted = useSetItemsDeleted();
    const deleteItems = useDeleteItems();
    useActionRegistryGlobalHandler([
        "UNARCHIVE"
    ], useCallback((items)=>{
        const itemIds = items.map((item)=>item.id);
        if (itemIds.length === 0) return false;
        setItemsArchived({
            items: [
                ...items
            ],
            isExplicitlyArchived: false
        });
        updateList(itemIds);
        return true;
    }, [
        setItemsArchived,
        updateList
    ]), {
        skip: view !== "archive"
    });
    useActionRegistryGlobalHandler([
        "UNDELETE",
        "PERMANENT_DELETE"
    ], useCallback((items, _event, command)=>{
        const itemIds = items.map((item)=>item.id);
        if (itemIds.length === 0) return false;
        const type = items.length === 1 ? "Leaf" : "Leaves";
        switch(command){
            case "UNDELETE":
                setItemsDeleted({
                    items: [
                        ...items
                    ],
                    isExplicitlyDeleted: false
                });
                updateList(itemIds);
                return true;
            case "PERMANENT_DELETE":
                deleteItems({
                    itemIds,
                    type
                });
                updateList(itemIds);
                return true;
            default:
                return false;
        }
    }, [
        deleteItems,
        setItemsDeleted,
        updateList
    ]), {
        skip: view !== "trash"
    });
    return /*#__PURE__*/ _jsx(TopicPageViewsTabsInfiniteList, _objectSpread({
        listId: "TopicPageViewsTabsPosts",
        items: posts,
        navigationListOptions: navigationListOptions
    }, rest));
};
export default TopicPageViewsTabsPosts;
